import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { stringify } from 'qs';
import 'rxjs/add/operator/map';

import { config } from '../../../../config';
import { Customer } from './customer.model';

interface CustomerReponse {
  data: Customer;
}

// interface CustomersReponse {
//   data: Customer[];
// }

@Injectable()
export class CustomerService {
  constructor(private http: HttpClient) {}

  get(terms?: object, page?: number, format?: string) {
    return this.http
      .get<any>(`${config.apiLocation}/v1/customers?${stringify({ terms, page , format})}`)
      .map(res => res);
  }

  getById(id: string, format: string = 'default'): Observable<Customer> {
    return this.http
      .get<CustomerReponse>(`${config.apiLocation}/v1/customers/${id}?format=${format}`)
      .map(res => res.data);
  }

  update(customer: RecursivePartial<Customer>): Observable<Customer> {
    return this.http
      .patch<CustomerReponse>(`${config.apiLocation}/v1/customers/${customer.id}`, customer)
      .map(res => res.data);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/data/customers/customer.service.ts